<template>
  <div class="editdorm-info">
    <!-- 编辑表单 -->
    <el-dialog
      title="修改宿舍信息"
      :visible="dialogFormVisible"
      width="400px"
      @close="dialogClose"
      @open="dialogOpen"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="宿舍号" label-width="100px" prop="dormName">
          <el-input
            v-model="ruleForm.dormName"
            autocomplete="off"
            placeholder="请输入宿舍号"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="宿舍楼名字" label-width="100px" prop="blockName">
          <el-input
            v-model="ruleForm.blockName"
            autocomplete="off"
            placeholder="请输入宿舍楼名字"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="宿舍规格" label-width="100px" prop="dormType">
          <!-- <el-input
            v-model="ruleForm.dormType"
            autocomplete="off"
            placeholder="请输入宿舍规格"
          ></el-input> -->
          <el-select v-model="ruleForm.dormType" placeholder="请选择宿舍规格">
            <el-option
              v-for="item in dictTypeList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" label-width="100px" prop="level">
          <el-input
            v-model="ruleForm.level"
            autocomplete="off"
            placeholder="请输入楼层"
            style="width: 235px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="form-btn">
        <!-- <el-button @click="dialogClose">取 消</el-button> -->
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      require: true,
    },
    dormInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dictTypeList: {
      type: Array,
    },
  },
  inject: ["refresh"],
  data() {
    return {
      ruleForm: {
        blockName: "",
        dormName: "",
        dormType: "",
        level: "",
      },
      rules: {
        dormName: [{ required: true, message: "请输入宿舍号", trigger: "blur" }],
      },
    };
  },
  methods: {
    dialogOpen() {
      let { blockName, dormName, dormType, level } = this.dormInfo;
      const item = this.dictTypeList.find((item) => +item.dictValue === dormType);
      dormType = item.dictLabel;
      this.ruleForm = { blockName, dormName, dormType, level };
    },
    dialogClose() {
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          // console.log("this.formData=> ", this.formData);
          let { blockName, dormName, dormType, level } = this.ruleForm;
          dormType = +dormType;
          // console.log(this.ruleForm);
          // 调用接口修改学生信息
          this.put(this.$url.editDorm, {
            id: this.dormInfo.id,
            blockName,
            dormName,
            dormType,
            level,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./editdorm-info.scss";
</style>
